import { createAction, props } from '@ngrx/store';
import { DbProp } from './db.prop';

export const setReady = createAction('[Db State] Set', props<DbProp>());
export const initialize = createAction('[Db State] Initialize', props<DbProp>());
